import axios from "axios";

export default class MasterdataService {

    static getEnlacesObjetivos() {
        return axios.get( `/api/objetivos` ).catch(err => console.err(err));
    }

    static getInfomacionHashtags(hashtag_id = 0) {
        return axios.get( `/api/hashtags/${hashtag_id}` ).catch(err => console.err(err));
    }

    static getInfomacion() {
        return axios.get( `/api/informacion` ).catch(err => console.err(err));
    }

    static getEstadoAgenda(locale) {
        return axios.get( `/api/estado-agenda/${locale}` ).catch(err => console.err(err));
    }
}
